import { ReactNode } from 'react';
import { ConditionalModalState } from './ConditionalModalState';
import { Translate } from '../services';

interface MessageModalLayoutProps {
  title?: string | ReactNode;
  content?: string | ReactNode;
  primaryButtonText?: string | ReactNode;
  secondaryButtonText?: string | ReactNode;
  theme?: 'standard' | 'premium' | 'destructive';
}

export interface BulkActionModalParams {
  readonly translate: Translate;
  readonly scrollToTop: () => unknown;
}

export class BulkActionModalState {
  readonly translate;
  readonly scrollToTop;

  readonly actionModal = new ConditionalModalState<
    Partial<MessageModalLayoutProps>
  >();

  constructor(params: BulkActionModalParams) {
    this.translate = params.translate;
    this.scrollToTop = params.scrollToTop;
  }

  openModal = () => {
    this.actionModal.modal.open();
  };

  closeModal = () => {
    this.actionModal.modal.close();
  };

  closeModalAndScrollTop = () => {
    this.closeModal();
    this.scrollToTop();
  };

  openConfirmModal = (props?: Partial<MessageModalLayoutProps>) => {
    const { translate: t } = this;
    this.actionModal.open({
      title: t('cairo.confirmModal.title'),
      primaryButtonText: t('cairo.confirm.button'),
      secondaryButtonText: t('cairo.cancel.button'),
      ...props,
    });
  };

  get isModalOpen() {
    return this.actionModal.isOpen;
  }
}
